/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_Code_CopiedInputs */

const cs_listing_code_copied = /** @type {(inputs: Listing_Code_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Číslo zakázky zkopírováno`)
};

const en_listing_code_copied = /** @type {(inputs: Listing_Code_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing number copied`)
};

/**
* | output |
* | --- |
* | "Listing number copied" |
*
* @param {Listing_Code_CopiedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const listing_code_copied = /** @type {((inputs?: Listing_Code_CopiedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_Code_CopiedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_code_copied(inputs)
	return cs_listing_code_copied(inputs)
});